import { AudioWavePlayer } from "@/component/AudioWavePlayer";
import { ArtifactsViewerData } from "@/hooks/useArtifactsViewerData";

import { SelectedAsset } from "@/store/assetsExplorer";

interface MusicTabProps {
  data: ArtifactsViewerData["music"]["data"];
  onSelect: (asset: SelectedAsset) => void;
  stopSignal?: number;
}

export function MusicTab(props: MusicTabProps) {
  const { data, onSelect, stopSignal } = props;

  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-text-tertiary">
        No music clips available
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {data.map((audio, index) => {
        if (!audio.url) {
          return null;
        }
        return (
          <div
            key={index}
            className="cursor-pointer"
            onClick={() => {
              // For music, we use the URL as both path and url
              // The actual file path might not be directly accessible
              onSelect({ type: "music", path: audio.url });
            }}
          >
            <AudioWavePlayer
              audioUrl={audio.url}
              title={audio.name}
              description={audio.description}
              downloadFilename={audio.downloadFilename}
              stopSignal={stopSignal}
            />
          </div>
        );
      })}
    </div>
  );
}
